import "./style.scss";

const Global = ({ children }: { children: JSX.Element }): JSX.Element => {
  return <div className='global'>{children}</div>;
};

export default Global;
